<template>
  <v-row>
    <v-col cols="12">
      <h2 >{{ $t("staff_status.head") }}</h2>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title> {{ $t("staff_status.head_list") }} </v-card-title>


        <v-card-actions class="pt-0">
          <v-data-table mobile-breakpoint="0" style="width: 100%" :headers="headers" :no-data-text="$t('not_found')"
            :no-results-text="$t('not_found')" :options.sync="pagination" :server-items-length="pagination.totalItems"
            :items-per-page="pagination.rowsPerPage" :page.sync="pagination.currentPage" :loading="loading" :footer-props="{
              'items-per-page-options': [10, 25, 30, 40, 50],
            }" :items="staffs">
            <template v-slot:[`item.status`]="{ item }">
              <v-btn  v-if="item.status === 'on'" color="#00FF00" class="text-white-bold" >
                on
              </v-btn>
              <v-btn disabled v-else   class="text-white-bold">
                off
              </v-btn>
            </template>

          </v-data-table>
        </v-card-actions>
      </v-card>
      <staff-show-detail :dialog="showDetail" :username="currentMemberDetail.username"
        :password="currentMemberDetail.password" :wallets="wallets" :deposit="depositwithdraw.deposit"
        :point="currentMemberDetail.point" :withdraw="depositwithdraw.withdraw" :depositWithdraw="depositwithdraw"
        @setDialog="showDetail = $event" />
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import DatePickerInput from '@/components/input/DatePickerInput.vue'
import SelectInput from '@/components/input/SelectInput.vue'
import StaffShowDetail from '@/views/staff/StaffShowDetail.vue'
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import store from '@/store'
import { addLogExportCSV } from '@/services/apis/logs'
import { mdiToothbrushElectric } from '@mdi/js'
import { staffStatus } from '@/utils/staffStatusUtils'
export default {
  components: {
    DatePickerInput,
    SelectInput,
    StaffShowDetail,
  },

  data() {
    return {
      startDate: moment().subtract(3, 'days').format('YY-MM-DD'),
      endDate: moment().format('YY-MM-DD'),
      menu: false,
      showDetail: false,
      toggle_exclusive: 0,
      dateFrom: moment().subtract(3, 'days').format('YY-MM-DD'),
      dateTo: moment().format('YY-MM-DD'),
      date: null,
      currentMemberDetail: {},
      searchData: null,
      headers: [
        {
          text: this.$t("staff_status.head1"),
          value: 'phone',
          sortable: false,
        },
        {
          text: this.$t("staff_status.head2"),
          value: 'name',
          sortable: false,
        },
        {
          text: this.$t("staff_status.head3"),
          value: 'email',
          sortable: false,
        },
        {
          text: this.$t("staff_status.head4"),
          value: 'line',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t("staff_status.head5"),
          value: 'status',
          align: 'center',
          sortable: false,
        }
      ],
      staffs: [],
      loading: false,
      dummy: true,
      canEdit: true,
      pagination: {
        currentPage: 1,
        rowsPerPage: 50,
        totalItems: 0,
      },
      wallets: [],
      depositwithdraw: { deposit: 0, withdraw: 0 },
      secureKey: null,
      isCreateUser: false,
      bankSystem: '',
      intervalId: null
    }
  },

  async created() {
    this.getWebSettingInfo()
    this.addLogPage()
    this.getStaff()
  },

  watch: {
    pagination: {
      async handler(newValue, oldValue) {
        let cont = false
        if (oldValue.page !== newValue.page) cont = true
        if (oldValue.itemsPerPage !== newValue.itemsPerPage) cont = true
        if (oldValue.sortBy !== newValue.sortBy) cont = true
        if (oldValue.sortDesc !== newValue.sortDesc) cont = true
        // if (cont) await this.searchPaginate(newValue.page, newValue.itemsPerPage)
      },
      deep: true,
    },
  },

  methods: {
    async getWebSettingInfo() {
      try {
        let settingWebInfo = await this.$store.dispatch('getSettingWebInfo')
        this.bankSystem = settingWebInfo?.bank_system[0] || 'TH';
      } catch (e) { }
    },
    async addLogPage() {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(res =>
          data = {
            ip: res.data.ip,
            name: 'สถานะพนักงาน',
            url: window.location.href,
            detail: 'ระบบสถานะพนักงาน',
            admin: userSystem.name ? userSystem.name : '' ? userSystem.name : '',
          }
        )
        await this.$store.dispatch('addLogPage', data)
      } catch (e) {
        // if (!e.message.includes('Unexpected token') || !e?.includes('Unexpected token') || !e.message.includes('Unexpected identifier')) {
        //   this.$swal.fire({
        //     icon: 'error',
        //     title: e.message,
        //   })
        // }
      }
    },
    async getStaff() {
      this.loading = true
      this.staffs = []
      let rs = await this.$store.dispatch('getEmployeeStatus', {})
      this.pagination.totalItems = rs.count
      rs.data.forEach(element => {
        this.staffs.push({
          id: element.id,
          phone: element.phone? element.phone : '',
          name: element.name ? element.name : '',
          email: element.email ? element.email : '',
          line: element.line ? element.line : '',
          status:'off'
        })
      })
      this.loading = false
    },
    formatDateYYYY(date) {
      const dateConv = date?.length > 8 ? date.substring(2) : date
      return moment(`20${dateConv}`).format('YYYY-MM-DD')
    },
  },
  mounted() {
    this.intervalId = setInterval(() => {
      for(let i=0;i<this.staffs.length;i++){
          this.staffs[i].status="off"
      }
      staffStatus.staffStatus.forEach((item, index) => {
        for(let i=0;i<this.staffs.length;i++){
          if(item.id==this.staffs[i].id){
            this.staffs[i].status="on"
          }
        }
      })
      console.log("Interrval > ",staffStatus.staffStatus)
    }, 5000)
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null
    }
  }
}
</script>
<style scoped>
@media (max-width: 550px) {
  .spacer {
    width: 100%;
  }
}
.text-white-bold {
  color: white;
  font-weight: bold;
  cursor: default !important;
}
</style>
